import {Component, OnInit, ViewChild} from '@angular/core';
import {UserPreferencesService} from './modules/shared/service/user-preferences.service';
import {TranslateService} from '@ngx-translate/core';
import {LocalizationService} from './modules/shared/service/localization.service';
import {AuthorizationService} from './modules/shared/service/authorization.service';
import {LoggerService} from './modules/shared/service/logger.service';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/internal/operators';
import {RequestErrorModalComponent} from '@npm.chapps.com/chapps.common.angular.library';
import { ManifestService } from './modules/shared/service/manifest.service';
import { UpdateService } from './modules/shared/service/update.service';
import { OfflineService } from './modules/shared/service/offline.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  @ViewChild(RequestErrorModalComponent) errorModal: RequestErrorModalComponent;
  public areTranslationsLoading: boolean;

  constructor(private userPreferencesService: UserPreferencesService, private translate: TranslateService,
              private localizationService: LocalizationService,
              private authorizationService: AuthorizationService, private loggerService: LoggerService, private router: Router,
              private manifestService: ManifestService,
              private updateService: UpdateService,
              private offlineService: OfflineService) {}

  ngOnInit() {
    this.offlineService.monitorConnection();
    this.updateService.checkForUpdates();
    this.manifestService.setManifest();
    this.areTranslationsLoading = true;
    this.translate.use(this.localizationService.getStartingLanguage()).subscribe(() => this.areTranslationsLoading = false);
    this.initErrorModal();
    this.localizationService.init();
    this.router.events
      .pipe(filter(e => e instanceof NavigationStart))
      .subscribe(e => this.logoutIfRequired(e as NavigationStart));
  }

  private logoutIfRequired(event: NavigationStart) {
    const isLogoutRequired = event.url.indexOf('/set-password/') >= 0;

    if (isLogoutRequired) {
      this.authorizationService.clearSession();
    }
  }

  public isUserLoggedIn(): boolean {
    return this.authorizationService.isUserLoggedIn();
  }

  public getFont(): string {
    return this.userPreferencesService.getFont();
  }

  public getTextColor(): string {
    return this.userPreferencesService.getTextColor();
  }

  public getBackgroundUrl(): string {
    return `url('${this.userPreferencesService.getBackgroundUrl()}')`;
  }

  private initErrorModal() {
    this.loggerService.error$.subscribe(() => this.errorModal.show());
  }
}
